const __WEBPACK_NAMESPACE_OBJECT__ = require("jsdoc-tsd-webpack-plugin");;